import React from 'react';
import { Bell } from 'lucide-react';

// Vorlaufzeiten in Minuten vor der Deadline (wie beim Kalender, plus 1-9 Tage)
export const REMINDER_OPTIONS = [
    { value: 30, label: '30 Min' },
    { value: 60, label: '1 Std' },
    { value: 120, label: '2 Std' },
    { value: 180, label: '3 Std' },
    ...[1, 2, 3, 4, 5, 6, 7, 8, 9].map(d => ({ value: d * 1440, label: d === 1 ? '1 Tag' : `${d} Tage` })),
];

export const formatReminder = (minutes) => {
    const opt = REMINDER_OPTIONS.find(o => o.value === minutes);
    if (opt) return opt.label;
    if (minutes >= 1440) return `${Math.round(minutes / 1440)} Tage`;
    if (minutes >= 60) return `${Math.round(minutes / 60)} Std`;
    return `${minutes} Min`;
};

/**
 * Mehrfachauswahl fuer Task-Erinnerungen ("X vor der Deadline").
 * value: Array von Minuten, onChange(Array)
 */
const TaskReminderPicker = ({ value = [], onChange, compact = false }) => {
    const toggle = (v) => {
        if (value.includes(v)) onChange(value.filter(x => x !== v));
        else onChange([...value, v].sort((a, b) => a - b));
    };
    return (
        <div className="flex flex-wrap gap-1.5" data-testid="task-reminder-picker">
            {REMINDER_OPTIONS.map(opt => {
                const active = value.includes(opt.value);
                return (
                    <button
                        key={opt.value}
                        type="button"
                        onClick={() => toggle(opt.value)}
                        className={`${compact ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs'} rounded-full border transition-colors ${
                            active
                                ? 'bg-primary text-primary-foreground border-primary'
                                : 'bg-background text-muted-foreground border-border hover:border-primary/50'
                        }`}
                        data-testid={`task-reminder-${opt.value}`}
                    >
                        {opt.label}
                    </button>
                );
            })}
            {value.length === 0 && (
                <span className="flex items-center gap-1 text-[11px] text-muted-foreground pl-1">
                    <Bell className="w-3 h-3" /> keine Erinnerung
                </span>
            )}
        </div>
    );
};

export default TaskReminderPicker;
